var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-follow-button button button-follow",class:{
    'button-yellow': _vm.followData.isFollowing,
    'button-white-bordered-yellow': !_vm.followData.isFollowing && !_vm.isBlackButton,
    'button-black-bordered-yellow': _vm.isBlackButton,
    'button-sm': _vm.isSmallButton,
  },attrs:{"disabled":_vm.followData.isProcessing},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.follow()}}},[(_vm.followData.isFollowing)?_c('span',[_vm._v("Following")]):_c('span',[_vm._v("Follow")])])}
var staticRenderFns = []

export { render, staticRenderFns }